import * as Terms from 'self-service-api/constants/Terms';
import { ANNUAL } from 'self-service-api/constants/Terms';
export const validateTermOrGetDefault = (term, defaultTerm = ANNUAL) => Object.values(Terms).includes(term) ? term : defaultTerm;